import { SelectedForMergeProvider } from "@/proposals/queries/SelectedForMerge.tsx";
import { registerAppProvider } from "@/shared/bootstrap/react.tsx";

registerAppProvider(SelectedForMergeProvider);
